export const MEMBER = { value: "MEMBER", key: "synchronizations.datatable.elementType.member" };
export const DEPENDENT_PERSON = { value: "DEPENDENT_PERSON", key: "synchronizations.datatable.elementType.dependentPerson" };
export const DIVISION = { value: "DIVISION", key: "synchronizations.datatable.elementType.division" };
export const CLIENT = { value: "CLIENT", key: "synchronizations.datatable.elementType.client" };
export const CLASS = { value: "CLASS", key: "synchronizations.datatable.elementType.class" };


// WEBPACK FOOTER //
// ./src/components/dashboard/synchronization/enums/syncElementTypes.js